import { render } from "./TotalMessages.vue?vue&type=template&id=253e6aca&scoped=true&ts=true"
import script from "./TotalMessages.vue?vue&type=script&lang=ts"
export * from "./TotalMessages.vue?vue&type=script&lang=ts"

import "./TotalMessages.vue?vue&type=style&index=0&id=253e6aca&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253e6aca"]])

export default __exports__